import type { TOC } from '@ember/component/template-only';

export interface BvCardFooterSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvCardFooterComponent: TOC<BvCardFooterSignature> = <template>
  <div class='bv-card__footer' ...attributes>
    {{yield}}
  </div>
</template>;

export default BvCardFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Footer': typeof BvCardFooterComponent;
    'bv-card/footer': typeof BvCardFooterComponent;
  }
}
